import { status, StatusType } from '../typeStatus'

export const GET_LOG_ACCESO = 'GET_LOG_ACCESO'
export const GET_LOG_ACCESO_SUCCESS = 'GET_LOG_ACCESO_SUCCESS'
export const GET_LOG_ACCESO_ERROR = 'GET_LOG_ACCESO_ERROR'
export const GET_LOG_ACCESO_RESET = 'GET_LOG_ACCESO_RESET'

export interface GetLogAccesoType {
  id: number
  inicialesNombre: string
  nombre: string
  apellido: string
  fechaInicio: Date
  fechaFin: Date
  ubicacion: string
  ip: string
  navegador: string
  so: string
  dispositivo: string
  tipoUsuario: string
}
export interface PaginationTypes {
  pageSize: number
  totalPages: number
  currentPage: number
  totalItems?: number
  totalItemsInPage: number
}
export interface LogsAccessList {
  pagination: PaginationTypes
  content: GetLogAccesoType[]
}
export interface GetLogAcceso {
  type: typeof GET_LOG_ACCESO
  payload: null
}

export interface GetLogAccesoSuccess {
  type: typeof GET_LOG_ACCESO_SUCCESS
  payload: LogsAccessList
}

export interface GetLogAccesoError {
  type: typeof GET_LOG_ACCESO_ERROR
  payload: null
}

export interface GetLogAccesoReset {
  type: typeof GET_LOG_ACCESO_RESET
  payload: null
}

export interface LogAccesoState {
  status: StatusType
  content: GetLogAccesoType[]
  pagination: PaginationTypes | null
}

export const initialState: LogAccesoState = {
  status: status.initial,
  content: [],
  pagination: null,
}

export type LogAccesoActions = GetLogAcceso | GetLogAccesoError | GetLogAccesoReset | GetLogAccesoSuccess
